export enum AccountStatus {
  Incomplete = 'INCOMPLETE',
  Unverified = 'UNVERIFIED',
  Completed = 'COMPLETED',
  Activated = 'ACTIVATED',
  Rejected = 'REJECTED',
  Deactivated = 'DEACTIVATED',
}
